export const LIST_LOADING = 'publish/LIST_LOADING';
export const LIST_LOADED_SUCCESS = 'publish/LIST_LOADED_SUCCESS';
export const LIST_LOADED_ERROR = 'publish/LIST_LOADED_ERROR';
export const pageLoadingStarted = () => ({ type: LIST_LOADING });
export const pageLoadedWithSuccess = (payload: any) => ({ payload, type: LIST_LOADED_SUCCESS });

export const DETAILS_SELECTED = 'publish/DETAILS_SELECTED';
export const DETAILS_LOADING = 'publish/DETAILS_LOADING';
export const DETAILS_LOADED_CACHE = 'publish/DETAILS_LOADED_CACHE';
export const DETAILS_LOADED_SUCCESS = 'publish/DETAILS_LOADED_SUCCESS';
export const DETAILS_LOADED_ERROR = 'publish/DETAILS_LOADED_ERROR';
export const listItemSelected = (payload: any) => ({ payload, type: DETAILS_SELECTED });
export const listItemDetailsWillLoad = () => ({ type: DETAILS_LOADING });
export const listitemDetailsLoadedWithSuccess = (payload: any) => ({ payload, type: DETAILS_LOADED_SUCCESS });
export const listItemDetailsLoadedWithCache = () => ({ type: DETAILS_LOADED_CACHE });

export const MODAL_OPEN = 'publish/MODAL_NEW_OPEN';
export const MODAL_CLOSE = 'publish/MODAL_CLOSE';
export const modalOpen = () => ({ type: MODAL_OPEN });
export const modalClose = () => ({ type: MODAL_CLOSE });

export const FORM_INACTIVE = 'publish/FORM_INACTIVE';
export const FORM_SUBMITTING = 'publish/FORM_SUBMITTING';
export const FORM_SUBMITTED_SUCCESS = 'publish/FORM_SUBMITTED_SUCCESS';
export const FORM_SUBMITTED_ERROR = 'publish/FORM_SUBMITTED_ERROR';
export const formReset = () => ({ type: FORM_INACTIVE });
export const formSubmitted = () => ({ type: FORM_SUBMITTING });
export const formSubmittedWithSuccess = () => ({ type: FORM_SUBMITTED_SUCCESS });
export const formSubmittedWithError = () => ({ type: FORM_SUBMITTED_ERROR });
